import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { USER_PLAN_SERVICE_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";

interface ActionState {
  isuseEffectRun: boolean;
  pinnedTab: string;
  pinIndex: null | number;
  isPinLoader: boolean;
}

const initialState: ActionState = {
  isuseEffectRun: true,
  pinnedTab: "",
  pinIndex: null,
  isPinLoader: false
};

const SLICE = "PropertyOverview";

export const fetchTabPinUnpin = createAsyncThunk(`${SLICE}/fetchPinTab`, (thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getPagePreferences, {}, thunkApi)
);

export const putTabPinUnpin = createAsyncThunk(`${SLICE}/postPinTab`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.putPagePreferences, data, thunkApi)
);

export const PropertyOverviewSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    setUseEffectState: (state, action) => {
      state.isuseEffectRun = action.payload;
    },
    setPinnedTab: (state, action) => {
      state.pinnedTab = action.payload;
    },
    setPinIndex: (state, action) => {
      state.pinIndex = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending(fetchTabPinUnpin, putTabPinUnpin), (state) => {
        state.isPinLoader = true;
      })
      .addMatcher(isRejected(fetchTabPinUnpin, putTabPinUnpin), (state) => {
        state.isPinLoader = false;
      })
      .addMatcher(isFulfilled(fetchTabPinUnpin, putTabPinUnpin), (state) => {
        state.isPinLoader = false;
      });
  }
});

export const { setUseEffectState, setPinnedTab, setPinIndex } = PropertyOverviewSlice.actions;
export default PropertyOverviewSlice.reducer;
